import {Prose} from "@client/components/Prose";
import {ratingRequestClass} from "@client/components/styles";
import * as typography from "@client/shared/typography";
import {reverse} from "@reactivated";
import * as React from "react";

export const RegisterRequest = () => (
    <div className={ratingRequestClass}>
        <Prose>
            <typography.P>
                Like this recipe and want to track it?{" "}
                <typography.A track="register_request" href={reverse("home_page")}>
                    Register
                </typography.A>{" "}
                for free and try out Joy.
            </typography.P>
            <typography.P>
                With Joy you can track your calories, macros, and cooking, regardless of
                your lifestyle.
            </typography.P>
            <typography.P>
                Joy supports any diet and <em>all</em> your goals.
            </typography.P>
        </Prose>
    </div>
);
